import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const NewQuestionButton = styled.button`
  width: 100%;
  background-color: transparent;
  border: 1px solid #393939;
  color: #393939;
  border-radius: 1rem;
  padding: 2rem;
  font-size: 1rem;
  font-weight: 600;
  font-family: Montserrat;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    transform: scale(0.98);
  }
`;